import { render, staticRenderFns } from "./HeaderButtons.vue?vue&type=template&id=c70d5eea&scoped=true"
import script from "./HeaderButtons.vue?vue&type=script&lang=js"
export * from "./HeaderButtons.vue?vue&type=script&lang=js"
import style0 from "./HeaderButtons.vue?vue&type=style&index=0&id=c70d5eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d5eea",
  null
  
)

export default component.exports